import React from "react";
import ship from "./data/data";
import { FaCircleDot } from "react-icons/fa6";
import MainLayout from "../../layouts/MainLayOut";

function Shipping() {
  return (
    <MainLayout>
      <div className="flex flex-col">
        <div
          className="flex-1 p-4 sm:p-6 md:p-10 2xl:px-[10vw] gap-8 text-slate-300 h-fit"
          style={{
            background:
              "radial-gradient(circle, rgba(51, 65, 85, 1) 1%, rgba(2, 6, 23, 1) 92%)",
          }}>
          {/* Header */}
          <div className="mb-6 border-b border-slate-600 pb-4">
            <h1 className="text-slate-50 font-bold text-3xl sm:text-4xl 2xl:text-[3vw] 2xl:leading-[3.5vw]">
              {ship.title}
            </h1>
            <span className="text-sm sm:text-base 2xl:text-[1.2vw] text-slate-400">
              {ship.effectiveDate}
            </span>
          </div>

          {/* Content Sections */}
          <div className="flex flex-col gap-8 text-sm sm:text-base 2xl:text-[1.1vw] 2xl:leading-[1.4vw]">
            {ship.sections.map((ele, ind) => (
              <div
                key={ind}
                className="bg-slate-800/30 rounded-xl p-4 md:p-6 shadow-md hover:shadow-lg transition-shadow duration-200">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-200 mb-2">
                  {ind + 1}. {ele?.heading}
                </h2>

                <div className="flex flex-col gap-3 ml-3">
                  {ele?.content && (
                    <p className="text-slate-300">{ele.content}</p>
                  )}

                  {ele?.subcontent && (
                    <p className="ml-4 text-slate-400">{ele.subcontent}</p>
                  )}

                  {ele?.exceptions && (
                    <div className="ml-4 flex flex-col gap-2">
                      {ele.exceptions.map((exception, idx) => (
                        <span
                          key={idx}
                          className="flex items-start gap-2 text-slate-300">
                          <FaCircleDot className="mt-1 text-primary" />
                          {exception}
                        </span>
                      ))}
                    </div>
                  )}

                  {ele?.instructions && (
                    <p className="text-slate-400">{ele.instructions}</p>
                  )}

                  {ele?.contactInfo?.email && (
                    <a
                      href={`mailto:${ele.contactInfo.email}`}
                      className="mt-2 text-slate-200 hover:text-primary hover:underline flex items-center gap-1">
                      📧 {ele.contactInfo.email}
                    </a>
                  )}

                  {ele?.contactInfo?.chat && (
                    <p className="text-slate-200 mt-1">
                      <span className="font-semibold">Chat:</span>{" "}
                      <span className="hover:underline">
                        {ele.contactInfo.chat}
                      </span>
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default Shipping;
